import { useContext, useMemo } from 'react';

import { Context } from '../providers/ViewportSizeProvider';

const defaultFallback = { height: '100vh' };

export interface ViewportSizeFallback {
  height?: string;
}

export const useViewportSize = (fallback?: ViewportSizeFallback) => {
  const context = useContext(Context);

  return useMemo(
    () => ({ ...defaultFallback, ...fallback, ...context }),
    [context, fallback],
  );
};
